'use client';

import { useSearchParams } from 'next/navigation';
import { getHomeQueryParams } from '@/utils/getHomeQueryParams';
import { useRegistrationStore } from '@/store/pages/registrationStore/registrationStore';

export const SURVEY_IDS_STATUSES_LIST = [
    '1465',
    '1466',
    '2947',
    '2950',
    '2948',
    '2949',
    '1345',
    '2945',
    '3075',
    '2946',
    '3173',
    '3310',
];
export const SURVEY_IDS_REGISTER_STATUSES_LIST = ['1465', '1466', '2948'];

export const PHYSICIAN_PROFESSION_ID = 1;
export const CONSUMER_PROFESSION_ID = 42;

export const useHomeQueryParams = () => {
    const searchParams = useSearchParams();

    const {
        surveyStatus,
        registrationType,
        templateId,
        externalSourceId,
        externalUserId,
        howHeardId,
        nonMemberToken,
        messageIdToShow,
        savedPaymentDetails,
    } = getHomeQueryParams(searchParams);

    const setHowHeardId = useRegistrationStore((state) => state.setHowHeardId);
    const checkForHowHeardIdAndUpdate = () => howHeardId && setHowHeardId(howHeardId);

    const isStatusInTheList =
        surveyStatus && SURVEY_IDS_STATUSES_LIST.includes(String(surveyStatus));
    const isAbleToRegisterStatus =
        surveyStatus && SURVEY_IDS_REGISTER_STATUSES_LIST.includes(String(surveyStatus));
    const isRegisterForFree = nonMemberToken && savedPaymentDetails;

    const queryProfessionId = (() => {
        switch (registrationType) {
            case 'consumer':
                return CONSUMER_PROFESSION_ID;
            case 'medical':
                return PHYSICIAN_PROFESSION_ID;
            case 'hcp':
                return PHYSICIAN_PROFESSION_ID;
            default:
                return;
        }
    })();

    return {
        registrationType,
        howHeardId,
        templateId,
        surveyStatus,
        externalSourceId,
        externalUserId,
        isStatusInTheList,
        isAbleToRegisterStatus,
        queryProfessionId,
        checkForHowHeardIdAndUpdate,
        nonMemberToken,
        isRegisterForFree,
        messageIdToShow,
    };
};
